import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Components
import NoSearchResults from '../../../../../../components/NoSearchResults';
import ResponsiveTable from '../../../../../../components/ResponsiveTable';
import TableCountDropdown from '../../../../../../components/TableCountDropdown';
import WorkTypesPagination from './components/WorkTypesPagination';
import WorkTypesTableHead from './components/WorkTypesTableHead';
import WorkTypesTableRow from './components/WorkTypesTableRow';

// Selectors
import { selectIds } from './selectors';

interface Props {
    ids?: number[];
}

export class WorkTypesTable extends React.PureComponent<Props> {
    render() {
        const { ids } = this.props;
        if (!ids || !ids.length) {
            return <NoSearchResults />;
        }
        return (
            <React.Fragment>
                <ResponsiveTable>
                    <Table
                        sortable
                        // fixed
                        striped
                        singleLine
                        unstackable
                        size="small"
                    >
                        <WorkTypesTableHead />
                        <Table.Body>
                            {ids.map(id => (
                                <WorkTypesTableRow key={id} workTypeId={id} />
                            ))}
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <TableCountDropdown defaultCount={25} />
                        <WorkTypesPagination />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectIds
});

export default connect(mapStateToProps)(WorkTypesTable);
